/**
 * REPLACE frontend/src/components/routes/FeatureRoute.jsx
 * WHY: Owner (isOwner=true) bypasses all feature gates entirely.
 */
import React from "react";
import { useSubscription } from "../../context/SubscriptionContext";
import { Lock } from "lucide-react";

export default function FeatureRoute({ feature, requiredTier, children }) {
  const { hasFeature, hasMinTier, tier, isOwner } = useSubscription();

  // Owner always has access
  if (isOwner) return <>{children}</>;

  const allowed = requiredTier ? hasMinTier(requiredTier) : hasFeature(feature);
  if (allowed) return <>{children}</>;

  const needed = requiredTier || feature;
  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"60vh", gap:20, padding:32, textAlign:"center" }}>
      <div style={{ width:60, height:60, borderRadius:"50%", background:"rgba(37,99,235,0.13)", display:"flex", alignItems:"center", justifyContent:"center" }}>
        <Lock size={26} color="var(--blue-lt)" />
      </div>
      <div>
        <div style={{ fontSize:18, fontWeight:700, fontFamily:"'DM Serif Display',serif", color:"var(--txt-hi)", marginBottom:8 }}>
          Feature Locked
        </div>
        <div style={{ fontSize:13, color:"var(--txt-mid)", maxWidth:380, lineHeight:1.6 }}>
          <strong style={{ textTransform:"capitalize" }}>{String(needed).replace(/_/g," ")}</strong> requires a higher plan.
          Your current plan: <strong style={{ textTransform:"capitalize" }}>{tier}</strong>.
        </div>
      </div>
      <a href="/billing" className="btn btn--primary">Upgrade Plan</a>
    </div>
  );
}

